import { Field, Item } from '@sitecore-jss/sitecore-jss-nextjs';

type GetEnumValueFn = <EnumType extends string>(
  enumItem: Item | undefined,
  defaultValue?: EnumType
) => typeof defaultValue extends undefined ? EnumType | '' : EnumType;

export const getEnumValue: GetEnumValueFn = <EnumType extends string>(
  enumItem: Item | undefined,
  defaultValue?: EnumType
): typeof defaultValue extends undefined ? EnumType | '' : EnumType =>
  ((enumItem?.fields?.Value as Field<string>)?.value || (defaultValue ?? '')) as EnumType;

export const hasEnumValue = (enumItem: Item | undefined): boolean =>
  !!enumItem &&
  !!enumItem.fields &&
  typeof enumItem.fields.Value === 'object' &&
  'value' in enumItem.fields.Value &&
  typeof enumItem.fields.Value.value === 'string' &&
  enumItem.fields.Value.value.trim() !== '';
